/* eslint import/no-extraneous-dependencies: "off" */
import React, { useLayoutEffect, useState } from "react";
import { Router } from "react-router-dom";
import { BrowserHistory, createBrowserHistory } from "history";

const customHistory = createBrowserHistory();

interface BrowserRouterProps {
  basename?: string;
  children?: React.ReactNode;
  window?: Window;
}
interface Props extends BrowserRouterProps {
  history: BrowserHistory;
}

export function DocblocRouter({ basename, children, history }: Props) {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), [history]);

  return (
    <Router
      basename={basename}
      children={children}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
}

export default customHistory;
